import clsx from 'clsx'
import React from 'react'
import { makeStyles, withStyles} from 'external/material'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import CreateHomeworkForm from './form'

const AddButton = withStyles(addButtonStyles)(Button)
const useStyles = makeStyles(createHomeworkStyles)

export default function CreateHomework ({context, hidden}) {

  const classes = useStyles()
  
  function handleOpenDialog() {        
    context.updateState({homeworkContext: {createHomework: {open: {$set: true}, editing: {$set: false}, editState: {$set: undefined}}}})
  }


  return (
    <Box className={clsx(classes.root, {hidden})}>
      <AddButton        
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleOpenDialog}
        className={classes.button}
      >
        {context.translate('create-homework')}
      </AddButton>     
      <CreateHomeworkForm context={context} />      
    </Box>
  )
}

function addButtonStyles() {
  return {
    root: {
      fontSize: '13pt',
      textTransform: 'capitalize',
      backgroundColor: '#2ca5ec',
      color: '#fff',
      '& svg': {
      },
      '&:hover': {
        backgroundColor: '#0069d9',
        borderColor: '#0062cc',
        boxShadow: 'none',
      },
    }
  }
}

function createHomeworkStyles() {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      '&.hidden': {
        display: 'none'
      },
    },
    button: {
      flexGrow: 1,
      margin: 15,
      marginTop: 24,
      paddingLeft: 30,
      paddingRight: 30
    },
    menu: {
    }
  }
}

